import React, { useContext, useEffect, useState } from 'react';
import bgImage from '../../../assets/images/couples/Vector.png';

import { SignupContext } from '../../../context/SignupContext';
import { LoginContext } from '../../../context/LoginContext';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { getOnboardingPath, isFullyOnboarded, getUserStatus } from '../../../utils/onboarding';

const SendOtp = () => {

  const { setAPIFormData, setIsLoggedIn: signUpIsLoggedIn, setUserId: SignUpUserId, setIsOtpSent } = useContext(SignupContext);
  const { isLoggedIn, userData, setUserName, setUserId, setUserdata, setIsLoggedIn, setPage, setOtpPending, logout } = useContext(LoginContext);
  const navigate = useNavigate();
  const [imobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loginMethod, setLoginMethod] = useState('password'); // password | otp
  const [error, setError] = useState(null);
  const [ip, setIp] = useState("not set");
  const [isSubmit, setIsSubmit] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");

  const userAgents = navigator.userAgent;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isSignupMode = searchParams.get('mode') === 'signup';
  const forceLogin = searchParams.get('force') === '1';

  useEffect(() => {

    // Header "Login" uses ?force=1 — always show the login form, never bounce to onboarding.
    if (forceLogin) {
      if (isLoggedIn) {
        logout();
      }
      if (loginMethod !== 'password') {
        setLoginMethod('password');
      }
      if (location.state?.message) {
        setInfoMessage(location.state.message);
      }
      getUserIP();
      return;
    }

    // Only auto-redirect when fully logged in (OTP already verified)
    if (isLoggedIn) {
      const status = getUserStatus(userData);

      // Pending session is stale after admin approval — clear it so user can log in fresh
      if (status === 3) {
        logout();
        setInfoMessage('If your account was approved, please log in with your mobile and password.');
        return;
      }

      const onboarding = getOnboardingPath(userData);
      if (onboarding) {
        navigate(onboarding);
      } else if (isFullyOnboarded(userData)) {
        navigate('/recently-joined-matches/');
      } else {
        navigate('/create-profile');
      }
    }

    if (location.state?.message) {
      setInfoMessage(location.state.message);
    }

    if (isSignupMode) {
      setLoginMethod('otp');
    } else {
      setLoginMethod('password');
    }

    getUserIP();

  }, [location, isLoggedIn, userData, forceLogin]);


  const getUserIP = () => {

    axios.get('https://api.ipify.org?format=json')
      .then((res) => {
        setIp(res.data.ip);
      })
      .catch((err) => console.log("error while fetching ", err));

  };


  const validateMobile = (value) => {
    const pattern = /^[6-9]\d{9}$/;
    return pattern.test(value);
  };

  const completePasswordLogin = (user, redirectUrl = '/recently-joined-matches') => {
    const uid = user?.user_id ?? user?.id;
    const status = Number(user?.status);
    setOtpPending(false);
    setIsLoggedIn(true);
    setUserName(user?.name);
    setUserId(uid);
    setUserdata({
      ...user,
      user_id: uid,
      id: uid,
      phone: user?.phone ?? imobile,
      status,
    });

    // Approved members always go to matches/cards
    let next = 'recently-joined-matches';
    if (status === 1) {
      next = (redirectUrl || '/recently-joined-matches').replace(/^\/+/, '');
    } else {
      const onboarding = getOnboardingPath({ ...user, status });
      next = (onboarding || redirectUrl || '/recently-joined-matches').replace(/^\/+/, '');
    }

    setPage(next);
    navigate('/' + next);
  };

  const handlePasswordLogin = async (e) => {
    e.preventDefault();
    const identifier = imobile.trim();
    if (!identifier) {
      setError("Please enter your Email or Mobile Number");
      return;
    }
    const isPhone = /^[6-9]\d{9}$/.test(identifier);
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(identifier);
    if (!isPhone && !isEmail) {
      setError("Please enter a valid 10-digit mobile number or valid email address.");
      return;
    }
    if (!password || password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setIsSubmit(true);
    setError("");

    try {
      const payload = new FormData();
      payload.append("email", identifier);
      payload.append("password", password);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}login_controller/login`,
        payload
      );

      if (response.data.response === 'failed') {
        const msg = response.data.message;
        setError(typeof msg === 'string' ? msg : Object.values(msg || {}).join('<br/>'));
      } else if (response.data.response === 'invalid') {
        setError(response.data.message);
      } else if (response.data.response === 'approval') {
        setError('');
        navigate('/account-pending-approval', {
          state: { message: response.data.message },
        });
      } else if (response.data.response === 'login') {
        // Password login — approved member
        completePasswordLogin(response.data.user, response.data.url || '/recently-joined-matches');
      } else if (response.data.response === 'redirect') {
        completePasswordLogin(response.data.user, response.data.url || '/recently-joined-matches');
      } else {
        setError("Something Went Wrong<br/>Try Again");
      }
    } catch (err) {
      console.log("Password login error", err);
      setError("Something Went Wrong<br/>Try Again");
    } finally {
      setIsSubmit(false);
    }
  };

  const handleMobile = async (e) => {
    e.preventDefault();
    if (!imobile || !imobile.trim()) {
      setError("Mobile is required");
      return;
    }
    if (!validateMobile(imobile)) {
      setError("Invalid mobile number.<br>Must start with 6-9 and be 10 digits.");
      return;
    }

    setIsSubmit(true);
    setError("");
    const payload = new FormData();
    payload.append("mobile", imobile);
    payload.append("ip", ip);
    payload.append("user_agent", userAgents);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}Register_controller/login_register_redirect`, payload)
        .then((response) => {
          if (response.data.response == "failed") {
            setError(response.data.message);
          }
          else if (response.data.response == "pending") {
            setError('');
            navigate('/account-pending-approval', {
              state: { message: response.data.message },
            });
          }
          else if (response.data.response == "otp" || response.data.response == "success") {
            setError('');
            const user = response.data.data || {};
            const uid = user?.user_id ?? user?.id;
            // Pending OTP only — not logged in yet
            setIsLoggedIn(false);
            setOtpPending(true);
            setUserName(user?.name || null);
            setUserId(uid || null);
            setUserdata({ ...user, phone: user?.phone ?? imobile, user_id: uid, id: uid });
            setPage(response.data.page || 'recently-joined-matches');
            setIsOtpSent(false);
            navigate("/otp");
          }
          else if (response.data.response == "redirect") {
            const user = response.data.data;
            const uid = user?.user_id ?? user?.id;
            setError('');
            signUpIsLoggedIn(true);
            SignUpUserId(uid);
            setAPIFormData(user);
            navigate("/" + response.data.page);

          }
          else if (response.data.response == "register") {
            const user = response.data.data;
            setError('');
            signUpIsLoggedIn(true);
            SignUpUserId(user?.user_id ?? null);
            setAPIFormData({ phone: imobile });
            setIsOtpSent(false);
            setIsLoggedIn(false);
            setOtpPending(false);
            setPage(response.data.page || 'sign-up');
            navigate("/otp");
          }
          else {
            setError("Something Went Wrong<br/>Try Again");
          }
        })
        .catch((err) => {
          console.log("Error while handling Otp and Login", err);
          setError("Something Went Wrong<br/>Try Again");
        });
    } catch (err) {
      console.log("Error while handling Otp and Login", err);
      setError("Something Went Wrong<br/>Try Again");
    } finally {
      setIsSubmit(false);
    }
  }

  return (
    <>
      <div className='py-md-5'></div>

      <div className='reset-wrapper'>
        <div className="reset-container">
          <div className="reset-left">
            <div className="login-panel">
              <header className="login-header">
                {isSignupMode && (
                  <p className="login-claim-line">
                    Claim Your <span>FREE</span> Registration
                  </p>
                )}
                <p className="login-brand">Hindu Sanjog</p>
                <h2>
                  {isSignupMode ? "Create your account" : "Welcome back"}
                </h2>
                <p className="subtitle">
                  {isSignupMode
                    ? "Enter your mobile number to verify and continue signup"
                    : (loginMethod === 'password'
                      ? "Sign in with your mobile number and password"
                      : "Enter your mobile number and verify OTP to sign in")}
                </p>
              </header>

              {!isSignupMode && (
                <div className="login-method-tabs" role="tablist" aria-label="Login method">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={loginMethod === 'password'}
                    className={loginMethod === 'password' ? 'tab active' : 'tab'}
                    onClick={() => { setLoginMethod('password'); setError(null); }}
                  >
                    Login with Password
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={loginMethod === 'otp'}
                    className={loginMethod === 'otp' ? 'tab active' : 'tab'}
                    onClick={() => { setLoginMethod('otp'); setError(null); }}
                  >
                    Login with OTP
                  </button>
                </div>
              )}

              {infoMessage && (<div className='alert alert-success text-center'>{infoMessage}</div>)}
              {error && (<div className='alert alert-danger text-center' dangerouslySetInnerHTML={{ __html: error }}></div>)}

              <form
                className="reset-form"
                onSubmit={(!isSignupMode && loginMethod === 'password') ? handlePasswordLogin : handleMobile}
              >
                <div className="form-field">
                  <label htmlFor="login-mobile">
                    {loginMethod === 'password' && !isSignupMode ? 'Email ID or Mobile Number' : 'Mobile Number'} <span className="req">*</span>
                  </label>
                  <input
                    id="login-mobile"
                    type={loginMethod === 'password' && !isSignupMode ? "text" : "tel"}
                    inputMode={loginMethod === 'password' && !isSignupMode ? "text" : "numeric"}
                    maxLength={loginMethod === 'password' && !isSignupMode ? undefined : 10}
                    value={imobile}
                    onChange={(e) => {
                      if (loginMethod === 'password' && !isSignupMode) {
                        setMobile(e.target.value);
                      } else {
                        setMobile(e.target.value.replace(/\D/g, '').slice(0, 10));
                      }
                    }}
                    placeholder={loginMethod === 'password' && !isSignupMode ? "Enter your Email or 10-digit Mobile" : "10-digit mobile number"}
                    autoComplete={loginMethod === 'password' && !isSignupMode ? "username" : "tel"}
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck="false"
                    style={{ textTransform: 'none' }}
                    required
                  />
                </div>

                {!isSignupMode && loginMethod === 'password' && (
                  <div className="form-field">
                    <div className="label-row">
                      <label htmlFor="login-password">Password <span className="req">*</span></label>
                      <a href="/forgot-password/" className="forgot-link">Forgot Password?</a>
                    </div>
                    <div className="password-field">
                      <input
                        id="login-password"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your password"
                        autoComplete="current-password"
                        autoCapitalize="none"
                        autoCorrect="off"
                        spellCheck="false"
                        style={{ textTransform: 'none' }}
                        required
                      />
                      <button
                        type="button"
                        className="eye-btn"
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </button>
                    </div>
                  </div>
                )}

                <label className="agree-row">
                  <input type="checkbox" required />
                  <span>
                    I agree to the{' '}
                    <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a>
                    {' '}and{' '}
                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                  </span>
                </label>

                <button type="submit" className="reset-button" disabled={isSubmit}>
                  {isSubmit
                    ? (loginMethod === 'password' && !isSignupMode ? "Logging in..." : "Sending OTP...")
                    : (isSignupMode
                      ? "Get OTP"
                      : (loginMethod === 'password' ? "Login" : "Get OTP & Login"))}
                </button>

                <p className="auth-switch">
                  {isSignupMode ? (
                    <>Already have an account? <a href="/login">Log In</a></>
                  ) : (
                    <>Don&apos;t have an account? <a href="/login?mode=signup">Sign Up</a></>
                  )}
                </p>
              </form>
            </div>
          </div>

          <div className="reset-right">
            <div className="image-overlay d-none d-lg-block">
              <img src={bgImage} alt="Side Visual" className="side-image" />
              <div className="image-text">
                <h3>Your Journey To Love Begins <span className="highlight">Here !</span></h3>
                <p>Connect With Genuine Matches Who<br />Share Your <span className="highlight">Values</span> And <span className="highlight">Dreams</span>.</p>
              </div>
            </div>
            <style>
              {`
.reset-wrapper {
  --hs-primary: #E53D5C;
  --hs-primary-dark: #c92f4b;
  --hs-text: #1f1f1f;
  --hs-muted: #6b7280;
  --hs-border: #e5e7eb;
  --hs-surface: #ffffff;
  --hs-bg: #f3f4f6;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background:
    radial-gradient(ellipse 80% 50% at 10% 0%, rgba(229, 61, 92, 0.08), transparent 50%),
    radial-gradient(ellipse 60% 40% at 90% 100%, rgba(229, 61, 92, 0.06), transparent 45%),
    var(--hs-bg);
  padding: 24px 16px;
}

.reset-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  max-width: 1080px;
  margin: 0 auto;
  background: var(--hs-surface);
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04), 0 12px 32px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.reset-left {
  flex: 1;
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-panel {
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
}

.login-header {
  margin-bottom: 28px;
  text-align: left;
}

.login-claim-line {
  margin: 0 0 14px;
  font-family: 'Playfair Display', 'Cinzel', Georgia, serif;
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.02em;
  color: #7b1828;
}

.login-claim-line span {
  color: #e53d5c;
  font-style: italic;
}

.login-brand {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--hs-primary);
}

.login-header h2 {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px;
  color: var(--hs-text);
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.subtitle {
  color: var(--hs-muted);
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.login-method-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin: 0 0 24px;
  padding: 4px;
  background: #f3f4f6;
  border-radius: 10px;
}

.login-method-tabs .tab {
  border: none;
  background: transparent;
  color: var(--hs-muted);
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.login-method-tabs .tab:hover {
  color: var(--hs-text);
}

.login-method-tabs .tab.active {
  background: var(--hs-surface);
  color: var(--hs-primary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.reset-form .form-field {
  margin-bottom: 18px;
}

.reset-form label {
  display: block;
  font-weight: 600;
  font-size: 13px;
  color: #374151;
  margin-bottom: 8px;
  text-align: left;
}

.reset-form label span {
  color: var(--hs-primary);
}

.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.label-row label {
  margin-bottom: 0;
}

.forgot-link {
  font-size: 12px;
  font-weight: 600;
  color: var(--hs-primary);
  text-decoration: none;
  white-space: nowrap;
}

.forgot-link:hover {
  text-decoration: underline;
}

.reset-form input[type="tel"],
.reset-form input[type="text"],
.reset-form input[type="password"],
.password-field input {
  width: 100%;
  padding: 12px 14px;
  margin-bottom: 0;
  border: 1px solid var(--hs-border);
  border-radius: 10px;
  font-size: 15px;
  color: var(--hs-text);
  background: #fafafa;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  outline: none;
}

.reset-form input[type="tel"]:focus,
.reset-form input[type="text"]:focus,
.reset-form input[type="password"]:focus,
.password-field input:focus {
  border-color: var(--hs-primary);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(229, 61, 92, 0.12);
}

.password-field {
  position: relative;
}

.password-field input {
  padding-right: 44px;
}

.eye-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
}

.eye-btn:hover {
  color: var(--hs-text);
}

.reset-form label.agree-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin: 4px 0 22px;
  cursor: pointer;
  font-weight: 400 !important;
  font-size: 13px !important;
  color: var(--hs-muted) !important;
  line-height: 1.45;
  text-align: left;
}

.reset-form label.agree-row input[type="checkbox"] {
  width: 16px !important;
  height: 16px !important;
  min-width: 16px !important;
  max-width: 16px !important;
  margin: 0 !important;
  flex-shrink: 0;
  accent-color: var(--hs-primary);
  cursor: pointer;
}

.reset-form label.agree-row > span {
  display: inline;
  padding-left: 0;
  flex: 1;
  min-width: 0;
}

.reset-form label.agree-row a {
  color: var(--hs-primary);
  font-weight: 600;
  text-decoration: none;
}

.reset-form label.agree-row a:hover {
  text-decoration: underline;
}

.reset-button {
  width: 100%;
  padding: 13px 16px;
  background-color: var(--hs-primary);
  color: white;
  font-size: 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  letter-spacing: 0.01em;
  transition: background 0.15s ease, transform 0.1s ease;
}

.reset-button:hover:not(:disabled) {
  background-color: var(--hs-primary-dark);
}

.reset-button:active:not(:disabled) {
  transform: translateY(1px);
}

.reset-button:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

.auth-switch {
  text-align: center;
  margin: 20px 0 0;
  font-size: 14px;
  color: var(--hs-muted);
}

.auth-switch a {
  color: var(--hs-primary);
  font-weight: 600;
  text-decoration: none;
}

.auth-switch a:hover {
  text-decoration: underline;
}

.reset-form .alert {
  border-radius: 10px;
  font-size: 13px;
  margin-bottom: 16px;
}

.reset-right {
  flex: 1.05;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 28px 28px 0;
  background: linear-gradient(160deg, #fff5f7 0%, #ffffff 55%);
}

.image-overlay {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  max-width: 480px;
  width: 100%;
}

.side-image {
  width: 100%;
  height: auto;
  display: block;
}

.image-text {
  position: absolute;
  bottom: 28px;
  left: 0;
  right: 0;
  color: white;
  font-size: 18px;
  line-height: 1.4;
  text-shadow: 0 2px 8px rgba(0,0,0,0.45);
  padding: 0 28px;
  text-align: center;
}

.image-text p {
  color: white !important;
  margin: 8px 0 0;
  font-size: 14px;
  opacity: 0.95;
}

.image-text h3 {
  font-size: 1.65rem;
  font-weight: 700;
  color: white !important;
  margin: 0;
}

.highlight {
  color: #ffc107;
  font-weight: 600;
}

@media (max-width: 992px) {
  .reset-wrapper {
    min-height: auto;
    padding: 16px 12px 32px;
  }

  .reset-container {
    flex-direction: column;
    padding: 0;
  }

  .reset-right,
  .reset-left {
    max-width: 100%;
    width: 100%;
    padding: 28px 20px;
  }

  .reset-right {
    display: none;
  }

  .login-header h2 {
    font-size: 24px;
  }

  .login-claim-line {
    font-size: 1.28rem;
  }

  .login-method-tabs .tab {
    font-size: 12px;
    padding: 9px 8px;
  }
}
`}
            </style>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendOtp;
